/* eslint-disable camelcase */
import { gql } from '@apollo/client'

import {
  Lots_lotsV2_LotsV2_results_LotV2,
  Lots_lotsV2_LotsV2_results_LotV2_riceLot_RiceLot,
  Lots_lotsV2_LotsV2_results_LotV2_riceLot_RiceLot_calendarV3_CalendarDateV3 as CalendarDate,
  Lots_lotsV2_LotsV2_results_LotV2_area_PolygonType,
  Lots_lotsV2_LotsV2_results_LotV2_location_PointType,
} from './types/index.graphql'

type RiceLot = Omit<Lots_lotsV2_LotsV2_results_LotV2_riceLot_RiceLot, 'calendarV3'> & {
  calendar: CalendarDate[]
}

type Lot = Omit<Lots_lotsV2_LotsV2_results_LotV2, 'riceLot' | 'area' | 'location'> & {
  riceLot: RiceLot
  area: Lots_lotsV2_LotsV2_results_LotV2_area_PolygonType
  location: Lots_lotsV2_LotsV2_results_LotV2_location_PointType
}

type LotWithArea = Omit<Lots_lotsV2_LotsV2_results_LotV2, 'area'> & {
  area: Lots_lotsV2_LotsV2_results_LotV2_area_PolygonType
  location: Lots_lotsV2_LotsV2_results_LotV2_location_PointType
}
interface LotResults extends Omit<Lots_lotsV2_LotsV2_results_LotV2, 'results'> {
  results: LotWithArea[]
}
interface Lots {
  lotsV2: LotResults
}

export type { Lot, CalendarDate, Lots }

export type { LotsVariables } from './types/index.graphql'

export const LOTS = gql`
  query Lots(
    $seasonId: Int!
    $fieldId: Int!
    $toYearMonth: String
    $fromYearMonth: String
    $includeMapUrls: Boolean!
  ) {
    lotsV2(seasonId: $seasonId, fieldId: $fieldId, discardWithoutArea: true) {
      results {
        id
        name
        size
        area {
          type
          coordinates
        }
        variety {
          id
          name
          isGrainHumidityAbsolute
          locales {
            es
            en
            pt
          }
        }
        crop {
          id
          locales {
            es
            en
            pt
          }
        }
        location {
          coordinates
          type
        }
        riceLot {
          id
          emergenceDate
          emergenceUpdateType
          harvestDate
          harvestUpdateType
          isHarvested
          calendarV3(fromYearMonth: $fromYearMonth, toYearMonth: $toYearMonth) {
            date
            daysSinceEmergence
            mapUrls {
              chlorophyll {
                url @include(if: $includeMapUrls)
                isAvailable
                weatherType
                provider
                indicator
                colorHistogram @include(if: $includeMapUrls) {
                  color
                  area
                }
              }
              irrigation {
                url @include(if: $includeMapUrls)
                isAvailable
                weatherType
                provider
                indicator
                emergenceDaysActivation
                colorHistogram @include(if: $includeMapUrls) {
                  color
                  area
                }
              }
              realImage {
                url @include(if: $includeMapUrls)
                isAvailable
                weatherType
                provider
              }
              grainHumidity {
                url @include(if: $includeMapUrls)
                isAvailable
                weatherType
                provider
                emergenceDaysActivation
                colorHistogram @include(if: $includeMapUrls) {
                  color
                  area
                }
              }
              water {
                url @include(if: $includeMapUrls)
                isAvailable
                weatherType
                provider
                emergenceDaysActivation
                colorHistogram @include(if: $includeMapUrls) {
                  color
                  area
                }
              }
              weeds {
                url @include(if: $includeMapUrls)
                isAvailable
                weatherType
                provider
                emergenceDaysActivation
                colorHistogram @include(if: $includeMapUrls) {
                  color
                  area
                }
              }
              emergence {
                url @include(if: $includeMapUrls)
                isAvailable
                weatherType
                provider
                emergenceDaysActivation
                colorHistogram @include(if: $includeMapUrls) {
                  color
                  area
                }
              }
            }
          }
        }
      }
    }
  }
`
